

  const seoContentDiv = document.getElementById('seoContent');
  if (seoContentDiv) {
    seoContentDiv.remove();
  }

  if (import.meta.env.VITE_ENV === 'production') {
    const script = document.createElement('script')
    script.setAttribute('async', '')
    script.setAttribute('defer', '')
    script.setAttribute('data-domain', 'app.manufy.com')
    script.src = 'https://plausible.io/js/plausible.js'
    document.head.appendChild(script)
  }

